import * as React from "react";
import { Link } from "react-router-dom";
import classnames from "classnames";
import { observer } from "mobx-react-lite";
import breadCrumbsStore from "../../store/breadCrumbs";
import { BreadCrumbsChevronIco } from "../../assets/customIcons";

import styles from "../styles/Breadcrumbs.module.scss";

const Breadcrumbs: React.FC = observer((props) => {
  const { data } = breadCrumbsStore;

  return (
    <div className={styles.BreadCrumbs}>
      {data.map((item, index, self) => (
        <React.Fragment key={item.link + item.name}>
          {index < self.length-1 ? (
            <Link
              className={classnames(
                styles.BradCrumbsItem,
                styles.BradCrumbsItemLink,
              )}
              to={item.link}
            >
              {item.name}
            </Link>
          ) : (
            <div className={styles.BradCrumbsItem}>{item.name}</div>
          )}
          <BreadCrumbsChevronIco />
        </React.Fragment>
      ))}
    </div>
  );
});

export default Breadcrumbs;